import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import globalUserProfile from '../../../../stores/global-user-profile';
import { UserType } from '../../../../api/types/user/user-type';
import { SalaryHistoryDbType } from '../../../../api/types/accountants/salary-history/salary-history.type';
import { MySalarySideBar } from './components/my-salary-side-bar';
import { MySalaryTable } from './components/my-salary-table';
import { getProfessorSalaryOperations } from './operations/get-professor-salary-operations';

export const MySalary = observer(() => {
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [salariesData, setSalariesData] = useState<SalaryHistoryDbType[]>([]);
  const [loading, setLoading] = useState(false);

  // Get the current user
  const getCurrentUser = () => {
    return globalUserProfile.userProfile?.userWithRole;
  };

  const currentUser = getCurrentUser();

  const fetchSalaryData = async (userId: number, start: Date, end: Date) => {
    setLoading(true);
    try {
      await getProfessorSalaryOperations(userId, start, end, setSalariesData);
    } finally {
      setLoading(false);
    }
  };

  const handleDateRangeChange = (
    newStartDate: Date | null,
    newEndDate: Date | null,
  ) => {
    setStartDate(newStartDate);
    setEndDate(newEndDate);
  };

  // Automatically fetch data when both dates are populated
  useEffect(() => {
    if (startDate && endDate && currentUser) {
      fetchSalaryData(currentUser.id, startDate, endDate);
    } else {
      // Clear data when dates are incomplete
      setSalariesData([]);
    }
  }, [startDate, endDate, currentUser]);

  // Check if user is a lecturer/professor
  if (
    !globalUserProfile.userProfile ||
    globalUserProfile.userProfile.userType !== UserType.LECTURER
  ) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <div>אין הרשאה לצפייה בדף זה</div>
      </div>
    );
  }

  if (!currentUser) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <div>טוען נתונים...</div>
      </div>
    );
  }

  return (
    <div
      style={{
        padding: '20px',
        backgroundColor: '#F9FAFB',
        minHeight: '100vh',
      }}
    >
      <div
        style={{
          color: '#041E49',
          fontSize: '30px',
          fontWeight: 'bold',
          marginBottom: '20px',
        }}
      >
        השכר שלי
      </div>

      <div style={{ display: 'flex', gap: '20px' }}>
        <MySalarySideBar
          startDate={startDate}
          endDate={endDate}
          onDateRangeChange={handleDateRangeChange}
        />

        <div style={{ flex: 1 }}>
          {loading ? (
            <div
              style={{
                backgroundColor: 'white',
                borderRadius: '8px',
                border: '1px solid #E5E7EB',
                padding: '40px',
                textAlign: 'center',
              }}
            >
              טוען נתונים...
            </div>
          ) : !startDate || !endDate ? (
            <div
              style={{
                backgroundColor: 'white',
                borderRadius: '8px',
                border: '1px solid #E5E7EB',
                padding: '40px',
                textAlign: 'center',
                color: '#6B7280',
              }}
            >
              בחר תאריך התחלה ותאריך סיום לצפייה בנתוני השכר
            </div>
          ) : (
            <MySalaryTable salariesData={salariesData} />
          )}
        </div>
      </div>
    </div>
  );
});
